'use strict';

module.exports = require('./').makeBaseProvider;
